import affiliateType from '$modules/affiliateType/routes'
// import areaOfState from '$modules/areaOfState/routes'
import division from '$modules/division/routes'
// import primaryGroup from '$modules/primaryGroup/routes'
import productService from '$modules/productService/routes'
// import workType from '$modules/workType/routes'
import supplyProvideService from '$modules/supplyProvideService/routes'
import primaryAreaOfConstruction from '$modules/primaryAreaOfConstruction/routes'
import csiCodes from '$modules/csiCodes/routes'

export default [
  {
    path: 'company',
    meta: {
      title: 'Companies',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'business'
    },
    component: () => import('./pages/index'),
    redirect: 'company/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'company',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'company',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Super Admin'],
          title: 'Add',
          resource: 'company',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      },
      {
        path: 'registrationLink',
        meta: {
          auth: ['Super Admin'],
          title: 'Registration Link',
          resource: 'company',
          icon: 'link',
          hidden: false
        },
        component: () => import('./pages/registrationLink')
      },
      {
        path: 'export',
        meta: {
          auth: ['Super Admin'],
          title: 'Export',
          resource: 'company',
          icon: 'get_app',
          hidden: false
        },
        component: () => import('./pages/export')
      }
    ].concat(affiliateType, productService, division, supplyProvideService, primaryAreaOfConstruction, csiCodes)
  }
]
